import React, { Component } from 'react';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { I18nextProvider } from 'react-i18next';
import i18n from "../i18n";
class CookieStorageIntlProvider extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        const { cookies } = props
        let langCookie = cookies.get('cvlrglang')
        const lang = langCookie ? langCookie.toLowerCase().split('_')[0] : 'en';
        let { initialLocale: locale } = props;
        if (lang) {
            locale = lang
        }
        this.state = { locale };
    }

    render() {
        return (
            <I18nextProvider i18n={i18n}>
                {this.props.children}
            </I18nextProvider>  
        );
    }
}

export default withCookies(CookieStorageIntlProvider);